import React from 'react';

const HealthChecker = () => (
  <div data-testid="health">Mapping Client service is healthy</div>
);

export default HealthChecker;
